import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import UserAlbum from './UserAlbum';
import UserUpload from './UserUpload';
import UserDedicate from './UserDedicate';
import { getlanguagelist } from "../../../../helpers/changelanguage";
import "./UserGallery.css";


function TabPanel(props) {
  const { children, value, index} = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function UserGallery(props) {


  let  languagelist = getlanguagelist();
  const classes = useStyles();
  const [value, setValue] = React.useState('album');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <div className="gallery_nav_area">
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="wrapped label tabs example">
          <Tab
            value="album"
            label={languagelist.album}
           
          />
          <Tab value="upload" label={languagelist.uploads} />
          <Tab value="dedicate" label={languagelist.dedicates}  />
        </Tabs>
      </AppBar>
      </div>
      <TabPanel value={value} index="album">
        <UserAlbum 
          galleryDetails = {props.galleryDetails} 
          deleteUserFeed = {props.deleteUserFeed}
          ownProfile     = {props.ownProfile}
        />
      </TabPanel>
      <TabPanel value={value} index="upload">
        <UserUpload galleryDetails={props.galleryDetails} changeCarousal={props.changeCarousal}/>
      </TabPanel>
      <TabPanel value={value} index="dedicate">
        <UserDedicate galleryDetails={props.galleryDetails} changeCarousal={props.changeCarousal} openDedicateLightBox={props.openDedicateLightBox}/>
      </TabPanel>
    </div>
  );
}


